var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCube = function SvgIconCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.14 1.212a1.73 1.73 0 0 1 1.72 0l8.25 4.64c.228.13.424.309.573.523a1 1 0 0 1 .134.227c.119.239.182.503.183.77v9.25h-1l1 .005a1.76 1.76 0 0 1-.89 1.52l-.004.003-8.246 4.638a1.73 1.73 0 0 1-1.72 0L2.894 18.15l-.003-.002A1.76 1.76 0 0 1 2 16.628V7.371a1.76 1.76 0 0 1 .189-.783 1 1 0 0 1 .121-.205c.15-.218.349-.4.58-.532l.004-.002zM12 3.023l6.965 3.918-6.885 3.911L5.05 6.933zM4 16.477V8.638l7.08 3.946-.067 7.838zm9.014 3.93L20 16.477V8.653l-6.92 3.932z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCube;